import React, { createContext, useContext, useEffect, useState } from "react";
import { deleteAllCookies, getCookie, reloadWindow, reloadWindowToPath, setCookie } from "../Helpers/Utils";
import { useDispatch } from "react-redux";

const AuthContext = createContext();

function AuthenticateProvider({ children }) {
  const [userDetails, setUserDetails] = useState({})
  const dispatch = useDispatch()
  const token = getCookie("sessionToken")
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const logIn = (token) => {
    if (token) {
      setCookie("sessionToken", token);
      setIsAuthenticated(true);
    }
  };
  const logOut = async () => {
    localStorage.removeItem('homeSearch')
    deleteAllCookies()
    setIsAuthenticated(false);
    setTimeout(() => {
      reloadWindowToPath('/login');
    }, 1500);
  }

  return (
    <AuthContext.Provider value={{ logIn, logOut, isAuthenticated, userDetails, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthenticateProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};